import { GridActionsCellItem, GridRowModes } from "@mui/x-data-grid";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/DeleteOutlined";
import SaveIcon from "@mui/icons-material/Save";
import CancelIcon from "@mui/icons-material/Close";

const columnBuilder = (props) => {
  const {
    regionData,
    rowModesModel,
    handleEditClick,
    handleSaveClick,
    handleDeleteClick,
    handleCancelClick,
    isAdmin = false,
  } = props;

  const columns = [
    { field: "id", headerName: "ID", width: 50, editable: false },
    {
      field: "branchName",
      headerName: "Abrechnungstelle *",
      type: "text",
      editable: isAdmin,
      width: 250,
    },
    {
      field: "title",
      headerName: "Title *",
      type: "text",
      editable: isAdmin,
      width: 100,
    },
    {
      field: "street",
      headerName: "Straße *",
      type: "text",
      editable: isAdmin,
      width: 140,
    },
    {
      field: "zip",
      headerName: "PLZ *",
      type: "number",
      editable: isAdmin,
      width: 100,
      valueFormatter: (params) => {
        const v = params?.value;
        if (v == null || (v !== 0 && !v)) return "";
        return "" + v;
      },
      renderCell: (params) => {
        const v = params?.value;
        if (v == null || (v !== 0 && !v)) return "";
        return v;
      },
    },
    {
      field: "regionId",
      headerName: "Ort (Region) *",
      type: "singleSelect",
      editable: isAdmin,
      width: 120,
      getOptionValue: (region) => region?.id,
      getOptionLabel: (region) => region?.regionName,
      valueOptions: regionData,
      valueFormatter: (params) => {
        try {
          if (!params?.value || !regionData) return "";
          const region = regionData.find(
            (region) => region.id === params.value
          );
          return region?.regionName || "";
        } catch (error) {
          console.error("Region formatting error:", error);
          return "";
        }
      },
      renderCell: (params) => {
        try {
          if (!params?.value || !regionData) return "";
          const region = regionData.find(
            (region) => region.id === params.value
          );
          return region?.regionName || "";
        } catch (error) {
          console.error("Region rendering error:", error);
          return "";
        }
      },
    },
    {
      field: "tel",
      headerName: "Tel",
      type: "text",
      editable: isAdmin,
      width: 100,
    },
    {
      field: "fax",
      headerName: "Fax",
      type: "text",
      editable: isAdmin,
      width: 100,
    },
    {
      field: "f_Name",
      headerName: "Beschreibung *",
      type: "text",
      editable: isAdmin,
      flex: 1,
    },
    {
      field: "f_Street",
      headerName: "Straße *",
      type: "text",
      editable: isAdmin,
      flex: 1,
    },
    {
      field: "f_zip",
      headerName: "PLZ *",
      type: "number",
      editable: isAdmin,
      width: 100,
      valueFormatter: (params) => {
        const v = params?.value;
        if (v == null || (v !== 0 && !v)) return "";
        return "" + v;
      },
      renderCell: (params) => {
        const v = params?.value;
        if (v == null || (v !== 0 && !v)) return "";
        return v;
      },
    },
    {
      field: "www",
      headerName: "WWW",
      type: "text",
      editable: isAdmin,
      flex: 1,
      renderCell: (params) => {
        const value = params?.value;
        if (value == null || value === "") return "";
        return (
          <a href={`${value}`} target="_blank" rel="noreferrer">
            {value}
          </a>
        );
      },
    },
    {
      field: "actions",
      type: "actions",
      headerName: "Actions",
      width: 100,
      cellClassName: "actions",
      getActions: ({ id }) => {
        const isInEditMode = rowModesModel[id]?.mode === GridRowModes.Edit;

        if (isInEditMode) {
          return [
            <GridActionsCellItem
              icon={<SaveIcon />}
              label="Save"
              onClick={handleSaveClick(id)}
              disabled={!isAdmin}
            />,
            <GridActionsCellItem
              icon={<CancelIcon />}
              label="Cancel"
              className="textPrimary"
              onClick={handleCancelClick(id)}
              color="inherit"
              disabled={!isAdmin}
            />,
          ];
        }

        return [
          <GridActionsCellItem
            icon={<EditIcon />}
            label="Edit"
            className="textPrimary"
            onClick={handleEditClick(id)}
            color="inherit"
            disabled={!isAdmin}
          />,
          <GridActionsCellItem
            icon={<DeleteIcon />}
            label="Delete"
            onClick={handleDeleteClick(id)}
            color="inherit"
            disabled={!isAdmin}
          />,
        ];
      },
    },
  ];

  return columns;
};

export default columnBuilder;
